import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgListNumber = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.33398 4.66848V1.17188C1.88305 1.2823 1.53848 1.59281 1.33398 2.00179M3.66732 10.6685H1.40597V10.3351C1.9941 9.92317 2.59679 9.53426 3.0788 8.99434C3.40078 8.63369 3.4364 8.09392 3.08941 7.73143C2.80757 7.437 2.32018 7.3405 1.94448 7.48662C1.69079 7.58528 1.54637 7.78294 1.40597 8.00181M13.0007 2.00181H6.33398M13.0007 6.00181H6.33398M13.0007 10.0018H6.33398",
		stroke: "#A1A1AA",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgListNumber);
export default ForwardRef;
